import { render, staticRenderFns } from "./custom-candidate-list.vue?vue&type=template&id=32f96844&scoped=true"
import script from "./custom-candidate-list.vue?vue&type=script&lang=ts"
export * from "./custom-candidate-list.vue?vue&type=script&lang=ts"
import style0 from "./custom-candidate-list.vue?vue&type=style&index=0&id=32f96844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f96844",
  null
  
)

export default component.exports